var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import KnockoutModel from "../../lib/knockout_model";
import { Page } from "../../lib/page-component";
import * as authorization from "../../lib/authorization";
import * as ajax from "../../app-lib/ajax_proxy";
var MyModel = /** @class */ (function (_super) {
    __extends(MyModel, _super);
    function MyModel(root) {
        var _this = 
        // 发送请求
        _super.call(this, "", root) || this;
        _this.dd = ko.observable();
        return _this;
    }
    MyModel.prototype.isLogin = function () {
        var _this = this;
        console.log('执行login的islogin');
        if (this.dd() != undefined) {
            window.localStorage.setItem('AccessToken', this.dd().token);
            console.log('更新token');
            ajax.get('/api/sso/info', {
                username: this.dd().userId,
                token: this.dd().token
            }).then(function (d) {
                if (d.message == '登录成功') {
                    window.localStorage.setItem('indexPage', d.data.indexPage);
                    window.localStorage.setItem('infomationPool', d.data.infomationPool);
                    window.localStorage.setItem('projectNotice', d.data.projectNotice);
                    window.localStorage.setItem('fileSystem', d.data.fileSystem);
                    window.localStorage.setItem('userDaily', d.data.userDaily);
                    window.localStorage.setItem('systemSetting', d.data.systemSetting);
                    window.localStorage.setItem('img', d.data.img);
                    window.localStorage.setItem('role', d.data.role);
                    var lastLoginTime = d.data.LastLogin.substring(0, d.data.LastLogin.length - 9).replace("T", " ");
                    window.localStorage.setItem('0', lastLoginTime);
                    window.localStorage.setItem('1', lastLoginTime);
                    window.localStorage.setItem('2', lastLoginTime);
                    window.localStorage.setItem('3', lastLoginTime);
                    window.localStorage.setItem('4', lastLoginTime);
                    window.localStorage.setItem('5', lastLoginTime);
                    window.localStorage.setItem('6', lastLoginTime);
                    window.localStorage.setItem('7', lastLoginTime);
                    window.localStorage.setItem("popur", '1');
                    console.log('登录成功');
                    authorization.login(d.data.userId, d.data.nickname, _this.dd().token);
                }
            });
        }
        else {
            console.log('未登录执行');
            authorization.signOut();
        }
    };
    return MyModel;
}(KnockoutModel));
var MyViewModel = /** @class */ (function (_super) {
    __extends(MyViewModel, _super);
    function MyViewModel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.hasLayout = false;
        return _this;
    }
    MyViewModel.prototype.init = function () {
        this.c = new MyModel(this.container);
    };
    MyViewModel.prototype.update = function (arg) {
        //   ko.postbox.publish(Topics.app_isDD,(n:any)=>new Date().getMilliseconds());
        if (arg.routeData.query.userId && arg.routeData.query.token) {
            window.localStorage.removeItem('UserId');
            window.localStorage.removeItem('AccessToken');
            window.localStorage.removeItem('Username');
            console.log('手动登出成功');
            this.c.dd(arg.routeData.query);
        }
        else {
            this.c.dd(undefined);
        }
        console.log('获取到登录值为：' + this.c.toJS(this.c.dd()));
        return this.c.isLogin();
    };
    MyViewModel.prototype.onInitComplete = function () {
    };
    return MyViewModel;
}(Page));
export default MyViewModel;
